var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-right-middle-bar"},[_c('p',{staticClass:"main-right-middle-bar-text"},[_vm._v(" 首页"),_c('span',{staticClass:"main-right-middle-bar-slash"},[_vm._v(" / ")]),_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }